import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import Loader from "../../../../components/Loader/Loader";
import './report.css';
import logo from "../../../../assets/img/profile/Emblem_of_Angola.png"
import BalancoTable from "./BalancoTable";
import {formatNumberToInternational, formatNumberConsiderZero} from "../../../../utils/utils";
export const FINANCIAL_HEAD = process.env.REACT_APP_FINANCIAL_HEAD;
export const EMBAIXADOR = process.env.REACT_APP_EMBAIXADOR;
export const COUNTRY = process.env.REACT_APP_COUNTRY;
const AccountSpecificReport = () => {
    const [loading, setLoading] = useState(false);
    const [accountNumberData, setAccountNumberData] = useState([]);
    const [orgName, setOrgName] = useState([]);
    const [cambioRate, setCambioRate] = useState([]);
    const [monthNameAndYear, setMonthNameAndYear] = useState([]);
    const [groupedInitialBalanceData, setGroupedInitialBalanceData] = useState([]);
    const [groupedDespesaData, setGroupedDespesaData] = useState([]);
    const [groupedRecitaData, setGroupedRecitaData] = useState([]);
    const [groupedRemainingBalanceData, setGroupedRemainingBalanceData] = useState([]);
    const [groupedDifferenceData, setGroupedDifferenceData] = useState([]);


    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // Extract query parameters
    const yearMonth = queryParams.get("yearMonth");
    const organizationId = queryParams.get("organizationId");
    const year = queryParams.get("year"); 
    const quarter = queryParams.get("quarter");


    useEffect(() => {
        fetchbankReport(organizationId, year, quarter);
    }, []);

    const fetchbankReport = async (organizationId, year, quarter) => {
        setLoading(true);
        try {
            let apiUrl = `${process.env.REACT_APP_API_URL}/v1/reports/balanco-quaterly?organizationId=${organizationId}&year=${year}&quarter=${quarter}`;
            const userToken = localStorage.getItem("token");
            const response = await fetch(apiUrl, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            });
            setLoading(false);

            if (response.ok) {
                const responseData = await response.json();
                if (responseData.data) {
                    const groupedsData = groupedProcessData(responseData.data);
                    setOrgName(responseData.data.organizationName);
                    setCambioRate(responseData.data.exchangeRateText);
                    setMonthNameAndYear(responseData.data.monthNameAndYear);
                    setAccountNumberData(responseData.data.accountNumber);
                    setGroupedInitialBalanceData(groupedsData.groupedInitialBalanceData);
                    setGroupedDespesaData(groupedsData.groupedDespesaData);
                    setGroupedRecitaData(groupedsData.groupedRecitaData);
                    setGroupedRemainingBalanceData(groupedsData.groupedRemainingBalanceData);
                    setGroupedDifferenceData(groupedsData.groupedDifferenceData);
                }
            } else {
                console.error('Error fetching API data:', response.status);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching API data:', error);
        }
    }
    const groupedProcessData = (data) => {
        // Handle null values with default 0 and format the required data
        const groupedInitialBalanceData = data.openingBalance.map((item) => ({
            descricao: item.description, // Matches 'descricao' accessor
            jpy: item.description.toLowerCase().includes('total') ? formatNumberConsiderZero(item.totalJpy) : formatNumberToInternational(item.totalJpy),
            usd: item.description.toLowerCase().includes('total') ? formatNumberConsiderZero(item.totalUsd) : formatNumberToInternational(item.totalUsd),
            eur: item.description.toLowerCase().includes('total') ? formatNumberConsiderZero(item.totalEur) : formatNumberToInternational(item.totalEur),
        }));

        const groupedRecitaData = data.receitaNature.map((item) => ({
            descricao: item.description,
            jpy: item.description.toLowerCase().includes('total') ? formatNumberConsiderZero(item.totalJpy) : formatNumberToInternational(item.totalJpy),
            usd: item.description.toLowerCase().includes('total') ? formatNumberConsiderZero(item.totalUsd) : formatNumberToInternational(item.totalUsd),
            eur: item.description.toLowerCase().includes('total') ? formatNumberConsiderZero(item.totalEur) : formatNumberToInternational(item.totalEur),
        }));

        const groupedDespesaData = data.despesaNature.map((item) => ({
            descricao: item.description,
            jpy: item.description.toLowerCase().includes('total') ? formatNumberConsiderZero(item.totalJpy) : formatNumberToInternational(item.totalJpy),
            usd: item.description.toLowerCase().includes('total') ? formatNumberConsiderZero(item.totalUsd) : formatNumberToInternational(item.totalUsd),
            eur: item.description.toLowerCase().includes('total') ? formatNumberConsiderZero(item.totalEur) : formatNumberToInternational(item.totalEur),
        }));

        const groupedRemainingBalanceData = data.closingBalance.map((item) => ({
            descricao: item.description,
            jpy: item.description.toLowerCase().includes('total') ? formatNumberConsiderZero(item.totalJpy) : formatNumberToInternational(item.totalJpy),
            usd: item.description.toLowerCase().includes('total') ? formatNumberConsiderZero(item.totalUsd) : formatNumberToInternational(item.totalUsd),
            eur: item.description.toLowerCase().includes('total') ? formatNumberConsiderZero(item.totalEur) : formatNumberToInternational(item.totalEur),
        }));

        const groupedDifferenceData = [
            {
                descricao: data.difference.description,
                jpy: data.difference.description.toLowerCase().includes('diiferenças cambias') ? formatNumberConsiderZero(data.difference.totalJpy) : formatNumberConsiderZero(data.difference.totalJpy),
                usd: data.difference.description.toLowerCase().includes('diiferenças cambias') ? formatNumberConsiderZero(data.difference.totalUsd) : formatNumberConsiderZero(data.difference.totalUsd),
                eur: data.difference.description.toLowerCase().includes('diiferenças cambias') ? formatNumberConsiderZero(data.difference.totalEur) : formatNumberConsiderZero(data.difference.totalEur),
            },
        ];

        return {
            groupedInitialBalanceData,
            groupedDespesaData,
            groupedRecitaData,
            groupedRemainingBalanceData,
            groupedDifferenceData
        };
    };


    const handlePrint = () => {
        window.print();
    };

    const formatYearMonth = (yearMonth) => {
        // Parse the yearMonth string
        // const [year, month] = yearMonth.split('-');

        // // Create a date object
        // const date = new Date(year, month - 1); // JavaScript months are 0-based

        // // Format the month name in Portuguese
        // return new Intl.DateTimeFormat('pt-BR', {month: 'long', year: 'numeric'}).format(date);
    };

    return (

        <div className="p-6">
            <Loader show={loading}/>
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="flex justify-between items-center mb-2 text-black dark:text-white">
                    <div className="flex-1 text-center">
                        <div className="flex items-center mb-5 justify-center h-[50px]">
                            <img
                                src={logo}
                                alt="Logo"
                                className="w-[60px] h-[80px] object-contain"
                            />
                        </div>
                        <h1 className="text-xl font-bold">REPÚBLICA DE ANGOLA</h1>
                        <h2 className="text-md">MINISTÉRIO DAS RELAÇÕES EXTERIORES</h2>
                        <h2 className="text-md">EMBAIXADA DA REPÚBLICA DE ANGOLA NO {COUNTRY}</h2>
                        <h2 className="text-md uppercase font-bold mt-2">BALANÇO TRIMESTRAL</h2>
                        <h2 className="text-md">MÊS DE {monthNameAndYear}</h2>
                        <h2 className="text-md uppercase font-bold mt-2" style={{textAlign: 'left'}}>{orgName}</h2>


                    </div>

                    <div className="text-right">
                        {/* <p className="text-md text-red-600">Câmbio: {cambioRate}</p> */}
                        {/* <p className="text-md">Nome: {bankName}</p> */}
                    </div>
                </div>

                {/* Print Button */}
                <div className="text-right mb-2">
                    <button
                        onClick={handlePrint}
                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 print:hidden">
                        Print
                    </button>
                </div>

                {/* Table */}
                {groupedInitialBalanceData?.length >= 0 && (
                    <BalancoTable tableData={groupedInitialBalanceData} tableName="SALDO DO MÊS ANTERIOR"/>
                )}


                <div className="mt-2"></div>
                {groupedRecitaData?.length >= 0 && (
                    <BalancoTable tableData={groupedRecitaData} tableName="ENTRADAS"/>
                )}


                <div className="mt-2"></div>
                {groupedDespesaData?.length >= 0 && (
                    <BalancoTable tableData={groupedDespesaData} tableName="SAÍDAS"/>
                )}


                <div className="mt-2"></div>
                {groupedRemainingBalanceData?.length >= 0 && (
                    <BalancoTable tableData={groupedRemainingBalanceData} tableName="SALDO P/ PRÓXIMO MÊS"/>
                )}


                <div className="mt-2"></div>
                {groupedDifferenceData?.length >= 0 && (
                    <BalancoTable tableData={groupedDifferenceData} tableName="DIFERENCA"/>
                )}

                <div className="mt-2"></div>
                {/* Footer */}
                <div className="flex justify-between mt-5">

                    <div>
                        <p>Encarregado de Serviço</p>
                        <hr className="mt-3 border-t-2 my-2" style={{borderTop: '2px solid black'}}/>
                    </div>
                    <div>
                    <p className="text-center">Adido Financeiro</p>
                    <p className="font-bold">{FINANCIAL_HEAD}</p>
                        <hr className="mt-3 border-t-2 my-2" style={{borderTop: '2px solid black'}}/>
                    </div>
                    <div>
                    <p className="text-center">Visto Embaixadora</p>
                    <p className="font-bold">{EMBAIXADOR}</p>
                        <hr className="mt-3 border-t-2 my-2" style={{borderTop: '2px solid black'}}/>
                    </div>
                </div>
            </div>


        </div>
    );
};

export default AccountSpecificReport;
